import { render, staticRenderFns } from "./StudentReferralLink.vue?vue&type=template&id=da5f7f34&scoped=true"
import script from "./StudentReferralLink.vue?vue&type=script&lang=js"
export * from "./StudentReferralLink.vue?vue&type=script&lang=js"
import style0 from "./StudentReferralLink.vue?vue&type=style&index=0&id=da5f7f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5f7f34",
  null
  
)

export default component.exports